// Footer_v8_medium.js - Balanced footer for Mantine v8
// Place in /mnt/project/Components/Footer.js

import { Box, Container, Group, Text, Anchor, Stack } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconPlane } from '@tabler/icons-react';

export function Footer({ isLoggedIn = false }) {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            style={{
                marginTop: 'auto',
                backgroundColor: '#1a1b1e',
                color: '#fff',
                padding: '2rem 0 1rem',
                borderTop: '1px solid #373A40',
                transition: 'margin-left 0.2s ease',
            }}
            ml={isLoggedIn ? { base: 0, sm: 250 } : 0}
        >
            <Container size="xl">
                <Stack gap="lg">
                    {/* Main Content */}
                    <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
                        {/* Left - Branding */}
                        <Stack gap={4} style={{ minWidth: 200 }}>
                            <Group gap="xs">
                                <Text fw={700} size="lg">
                                    Lidosta Spilve
                                </Text>
                                <IconPlane size={24} color="#4dabf7" />
                            </Group>
                            <Text size="sm" c="dimmed">
                                Daugavgrīvas iela 140, Rīga
                            </Text>
                        </Stack>

                        {/* Center - Legal Links */}
                        <Stack gap={4} style={{ minWidth: 180 }}>
                            <Text fw={600} size="sm" mb={4}>
                                Juridiskā informācija
                            </Text>
                            <Anchor
                                component={Link}
                                to="/legal/terms"
                                size="sm"
                                c="dimmed"
                                style={{ textDecoration: 'none' }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#4dabf7'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#909296'}
                            >
                                Lietošanas noteikumi
                            </Anchor>
                            <Anchor
                                component={Link}
                                to="/legal/data-processing"
                                size="sm"
                                c="dimmed"
                                style={{ textDecoration: 'none' }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#4dabf7'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#909296'}
                            >
                                Datu apstrāde
                            </Anchor>
                            <Anchor
                                component={Link}
                                to="/legal/privacy"
                                size="sm"
                                c="dimmed"
                                style={{ textDecoration: 'none' }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#4dabf7'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#909296'}
                            >
                                Privātuma politika
                            </Anchor>
                        </Stack>

                        {/* Right - Contact */}
                        <Stack gap={4} style={{ minWidth: 150 }}>
                            <Text fw={600} size="sm" mb={4}>
                                Kontakti
                            </Text>
                            <Anchor
                                href="mailto:info@spilve.org"
                                size="sm"
                                c="dimmed"
                                style={{ textDecoration: 'none' }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#4dabf7'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#909296'}
                            >
                                info@spilve.org
                            </Anchor>
                        </Stack>
                    </Group>

                    {/* LIAA Support */}
                    <Stack align="center" gap={4} pt="xs" style={{ borderTop: '1px solid #373A40' }}>
                        <img
                            src="/finanse.png"
                            alt="LIAA"
                            style={{ maxHeight: 60, objectFit: 'contain' }}
                        />
                        <Text size="xs" c="dimmed" ta="center">
                            Projekts tapis ar LIAA atbalstu
                        </Text>
                    </Stack>

                    <Group justify="space-between" pt="xs" wrap="wrap">
                        <Text size="xs" c="dimmed">
                            © {currentYear} Lidosta Spilve
                        </Text>
                    </Group>
                </Stack>
            </Container>
        </Box>
    );
}